import { connect } from 'react-redux'
import * as action from '../../state/quotation/action'
import * as selector from '../../state/quotation/selector'
import TreatmentQuotation from './TreatmentQuotation'
import { PRODUCT_TYPE_ALIGNERS } from '../../state/quotation/const'
import * as planSelector from "../../state/plan/selector";

const mapStateToProps = (state, props) => {
    return {
        treatmentQuotation: selector.selectTreatmentQuotation(state),
        customer: selector.selectCustomer(state),
        isPreviewModalOpen: selector.selectIsPreviewModalOpen(state),
        isValid: selector.selectIsTreatmentQuotationValid(state),
        uploadingVideo: selector.selectIsUploadingVideo(state),
        isEditableForUser: selector.selectIsEditableForUser(state),
        hasUserRoleToEdit: selector.selectHasUserRoleToEdit(state),
        productType: PRODUCT_TYPE_ALIGNERS,
        treatmentPlan: planSelector.selectTreatmentPlan(state),
    }
}

const mapDispatchToProps = {
    findOrCreateTreatmentQuotation: action.findOrCreateTreatmentQuotation,
    changeTreatmentQuotation: action.changeTreatmentQuotation,
    saveTreatmentQuotation: action.saveTreatmentQuotation,
    openPreviewModal: action.openPreviewModal,
    closePreviewModal: action.closePreviewModal,
    uploadVideoFile: action.uploadVideoFile,
    updatePackageAndPrice: action.updatePackageAndPrice,
    setEditableForUser: action.setEditableForUser,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TreatmentQuotation)



// WEBPACK FOOTER //
// ./src/modules/treatment/component/quotation/TreatmentQuotationContainer.js